import cx from 'classnames';
import React, { useRef, useEffect } from 'react';
import { Portal } from 'react-portal';
import { useSlate } from 'slate-react';
import Separator from '@plone/volto-slate/editor/ui/Separator';
import BasicToolbar from '@plone/volto-slate/editor/ui/BasicToolbar';
import { Editor, Node } from 'slate';
import { ReactEditor } from 'slate-react';

// Customized Toolbar override to avoid crashes when Slate node -> DOM mapping is temporarily unavailable
const Toolbar = ({ elementType, enableExpando = false, toggleButton, className, children, show = true }) => {
  const ref = useRef();
  const editor = useSlate();

  useEffect(() => {
    const domNode = ref.current;
    if (!domNode) return;

    let rect = { width: 1, top: 0, left: 0 };

    if ((children || []).length === 0) {
      domNode.removeAttribute('style');
      return;
    }

    if (!show) {
      domNode.removeAttribute('style');
      return;
    }

    const { selection } = editor;
    if (!selection) {
      domNode.removeAttribute('style');
      return;
    }

    if (editor.isSidebarOpen) {
      domNode.removeAttribute('style');
      return;
    }

    if (elementType) {
      const [element] = Editor.nodes(editor, {
        at: editor.selection || editor.getSavedSelection(),
        match: (n) => n.type === elementType,
      });

      if (!element) {
        domNode.removeAttribute('style');
        return;
      }

      const [node] = element;
      try {
        const domEl = ReactEditor.toDOMNode(editor, node);
        rect = domEl.getBoundingClientRect();
      } catch (e) {
        // Node might have been normalized/removed (e.g., when editing link URL)
        domNode.removeAttribute('style');
        return;
      }
    } else {
      try {
        const slateNode = Node.get(editor, selection.anchor.path);
        const domEl = ReactEditor.toDOMNode(editor, slateNode);
        rect = domEl.getBoundingClientRect();
      } catch (e) {
        domNode.removeAttribute('style');
        return;
      }
    }

    domNode.style.opacity = 1;
    domNode.style.top = `${rect.top + window.pageYOffset - domNode.offsetHeight - 6}px`;
    domNode.style.left = `${Math.max(rect.left + window.pageXOffset - domNode.offsetWidth / 2 + rect.width / 2, 0)}px`;
  });

  return (
    <Portal>
      <BasicToolbar className={cx('slate-inline-toolbar', { [className]: className })} ref={ref}>
        {children}
        {enableExpando && toggleButton && (
          <>
            <Separator />
            {toggleButton}
          </>
        )}
      </BasicToolbar>
    </Portal>
  );
};

export default Toolbar;
